import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import logo from "../../assets/img/logo.png";

const Header = () => {
  const [expanded, setExpanded] = useState(false);

  const scrollToSiniestro = () => {
    const target = document.getElementById("tengo-un-siniestro");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
      setExpanded(false); // Cierra el menú si está abierto en mobile
    }
  };

  return (
    <Navbar expand="lg" expanded={expanded} className="mc-header sticky-top">
      <Container>
        {/* Logo */}
        <Navbar.Brand href="#">
          <img src={logo} alt="MC Brokers" className="img-fluid logo" />
        </Navbar.Brand>

        {/* Mobile view: siniestro + toggle */}
        <div className="d-lg-none d-flex align-items-center gap-3">
          <Button className="siniestro-btn" onClick={scrollToSiniestro}>
            Tengo un Siniestro
          </Button>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)}>
            <FaBars className="menu-icon" />
          </Navbar.Toggle>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto d-lg-flex gap-4 mc-nav">
            <Nav.Link
              href="https://www.wopdigital.com.ar/clients/mcbrokers/institucional/"
              target="_blank"
              onClick={() => setExpanded(false)}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="https://www.wopdigital.com.ar/clients/mcbrokers/productos/"
              className="active"
              onClick={() => setExpanded(false)}
            >
              Productos
            </Nav.Link>
          </Nav>

          {/* Desktop button */}
          <div className="d-none d-lg-block">
            <Button className="siniestro-btn" onClick={scrollToSiniestro}>
              Tengo un Siniestro
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
